module.exports = __webpack_public_path__ + "components/country-flag/static/is-44ff0642920f4626b1149738c59f15c8.svg";